export enum LabelPayerReason {
  RedoPaysAllLabels = "REDO_PAYS_ALL_LABELS",
  RedoOrderHasFinalSaleProtection = "REDO_ORDER_HAS_FINAL_SALE_PROTECTION",
  RedoOrderHasReturnsCoverage = "REDO_ORDER_HAS_RETURNS_COVERAGE",
  RedoOrderHasWarrantyCoverage = "REDO_ORDER_HAS_WARRANTY_COVERAGE",
  RedoRecyclingSetting = "REDO_RECYCLING_SETTING",
  MerchantDamagedOrWrongProduct = "MERCHANT_DAMAGED_OR_WRONG_PRODUCT",
  MerchantSafetyNet = "MERCHANT_SAFETY_NET",
  MerchantRecyclingSetting = "MERCHANT_RECYCLING_SETTING",
  ShopperUncovered = "SHOPPER_UNCOVERED",
  ShopperRecyclingSetting = "SHOPPER_RECYCLING_SETTING",
}
